routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.routinesList', {
      url: "/consultas/rutinas",
      template: `<routines-list  sh-ctrl="shCtrl"></routines-list>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-list/routines-list.config.js
 **/